module.exports = {
    'Sound': 'https://miamisoundrental.com/sound-system-rental',
    'Lighting': 'https://miamisoundrental.com/lighting-rental',
    'DJ Equipment': 'https://miamisoundrental.com/dj-equipment-rental',
    'Staging': 'https://miamisoundrental.com/stage-rental',
    'Visuals': 'https://miamisoundrental.com/visuals',
    'Special Effects': 'https://miamisoundrental.com/special-effects',

    'Production': 'https://miamisoundrental.com/equipment/production',
    'Microphones': 'https://miamisoundrental.com//microphone-rental',
    'Main Speakers': 'https://miamisoundrental.com//speaker-rental',
    'Karaoke': 'https://miamisoundrental.com//karaoke-rental',
    'TVs': 'https://miamisoundrental.com//tv-rental',
    'Video Wall': 'https://miamisoundrental.com/led-video-wall-rental',
    'Projector': 'https://miamisoundrental.com/projector-rental',
    'Stage Risers': 'https://miamisoundrental.com/stage-rental',
    'Stage Bundles': 'https://miamisoundrental.com/stage-rental',
}